import { Grid, Autocomplete, TextField } from "@mui/material";
import PrettyNumberTextField from "components/common/PrettyNumberTextField";
import * as labels from "config.labels";
import { TRIA_STATUS_INCLUDED_GROSS_UP_OPTION } from "flags";
import * as staticDataHooks from "store/hooks/staticDataHooks";

const TriaStatus = ({ layer, updateLayer }) => {
  const translateLabel = staticDataHooks.useTranslator("uiLabels");

  const { isVisible: offerIncludedGrossUp } = staticDataHooks.useIsVisible(
    TRIA_STATUS_INCLUDED_GROSS_UP_OPTION
  );

  const triaStatuses = [
    {
      key: "NOT_INCLUDED",
      label: translateLabel(
        labels.ACTIVE_LAYER_PANEL_TRIA_STATUS_NOT_INCLUDED,
        {
          default: "Not Included",
        }
      ),
    },
    {
      key: "INCLUDED",
      label: translateLabel(labels.ACTIVE_LAYER_PANEL_TRIA_STATUS_INCLUDED, {
        default: "Included",
      }),
    },
    {
      key: "GROSS_UP",
      label: translateLabel(labels.ACTIVE_LAYER_PANEL_TRIA_STATUS_GROSS_UP, {
        default: "Gross Up",
      }),
    },
    // Offered only to companies with the visibility flag on, but always kept
    // in the list when the layer already holds the status — turning the flag
    // off must never blank an existing layer's value (the calculation is
    // status-driven either way; the flag only controls whether the option is
    // offered).
    ...(!!offerIncludedGrossUp || layer?.triaStatus === "INCLUDED_GROSS_UP"
      ? [
          {
            key: "INCLUDED_GROSS_UP",
            label: translateLabel(
              labels.ACTIVE_LAYER_PANEL_TRIA_STATUS_INCLUDED_GROSS_UP,
              {
                default: "Included (Gross Up)",
              }
            ),
          },
        ]
      : []),
  ];

  return (
    <>
      <Grid item xs={12} md={6}>
        <Autocomplete
          value={
            triaStatuses.find(({ key }) => key === layer?.triaStatus) ?? null
          }
          onChange={(_, value) =>
            updateLayer({
              triaStatus: value?.key ?? null,
            })
          }
          options={triaStatuses}
          renderInput={(params) => (
            <TextField
              {...params}
              variant={"filled"}
              label={translateLabel(
                labels.ACTIVE_LAYER_PANEL_TRIA_STATUS_LABEL,
                {
                  default: "TRIA Status",
                }
              )}
              InputLabelProps={{ shrink: true }}
            />
          )}
          autoHighlight
          sx={{ width: "100%" }}
          disableClearable
        />
      </Grid>
      <Grid item xs={12} md={6}>
        {layer?.triaStatus !== "NOT_INCLUDED" && (
          <PrettyNumberTextField
            type={"text"}
            InputLabelProps={{ shrink: true }}
            label={translateLabel(labels.ACTIVE_LAYER_PANEL_TRIA_LABEL, {
              default: "TRIA",
            })}
            id={"layer-pricing-tria"}
            variant={"percentage"}
            onChangeNumber={(TRIA) => updateLayer({ TRIA })}
            value={layer?.TRIA ?? 0}
            fullWidth
          />
        )}
      </Grid>
    </>
  );
};

export default TriaStatus;
